import { ComponentPropsWithoutRef } from 'react';
import { formatDate } from '../../../helpers/format-date';
import { mergeClasses } from '../../../helpers/merge-classes';
import { NakedButton } from '../../../naked/naked-button.component';
import { useCalendarState } from '../provider/calendar.provider';
import type { BaseAtomProps } from './calendar-atom.types';

type Props = BaseAtomProps & {
  month: number;
  year: number;
};

type CalendarMonthsProps = Props & Omit<ComponentPropsWithoutRef<'div'>, keyof Props>;

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const CalendarMonths = ({ className, month, year, ...rest }: CalendarMonthsProps) => {
  const { getMonthButtonProps } = useCalendarState();
  return (
    <div className={mergeClasses('calendar__months__years', className)} {...rest}>
      {months.map((month, i) => (
        <NakedButton
          {...getMonthButtonProps(formatDate(new Date(year, i), 'YYYY-MM'), i)}
          key={i}
          className='cal__months'
          type='button'
        >
          {month}
        </NakedButton>
      ))}
    </div>
  );
};
